import React from 'react'
import {
    ContactContainer, ContactWrap, ContactContent, ContactForm,
    FormButton, FormH1, FormInput, FormLabel, FormArea,
} from './ContactElements'

const Contact = () => {
    return (
        <ContactContainer id="contact" className="primaryBackground">
            <ContactWrap>
                <ContactContent>
                    <ContactForm method="POST" action='https://formspree.io/f/xgepllob'>
                        <FormH1 className="lightColor">Contactez moi</FormH1>
                        <FormLabel className="lightColor" htmlFor='for'>Prenom</FormLabel>
                        <FormInput name="name" type='text' required></FormInput>
                        <FormLabel className="lightColor" htmlFor='for'>Email</FormLabel>
                        <FormInput name="_replyto" type='email' required></FormInput>
                        <FormLabel className="lightColor" htmlFor='for'>Message</FormLabel>
                        <FormArea rows='10' name="message" type='text' required></FormArea>
                        <FormButton className="darkPrimaryBackground lightColor" type='submit'>Envoyer</FormButton>
                    </ContactForm>
                </ContactContent>
            </ContactWrap>
        </ContactContainer>
    )
}

export default Contact
